var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8458 3.84341C18.1297 2.90277 17.1181 2.23008 15.9736 1.93341C14.8291 1.63674 13.618 1.73331 12.535 2.20761C11.5657 2.62582 10.7011 3.33093 10 4.26666C9.29886 3.32865 8.43433 2.62354 7.46499 2.20761C6.38197 1.73331 5.17093 1.63674 4.02641 1.93341C2.88189 2.23008 1.87033 2.90277 1.15423 3.84341C0.399085 4.83267 0 6.06902 0 7.41838C0 9.36029 1.15835 11.4907 3.44256 13.7529C5.30389 15.5956 7.50343 17.1046 8.64851 17.8399C9.05198 18.0981 9.52098 18.2353 10 18.2353C10.479 18.2353 10.948 18.0981 11.3515 17.8399C12.4957 17.1046 14.6961 15.5956 16.5574 13.7529C18.8416 11.4916 20 9.36029 20 7.41838C20 6.06902 19.6009 4.83267 18.8458 3.84341Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikes);
export default __webpack_public_path__ + "static/media/Likes.7ab2e45bc2a4f92cb552405a38c2f7d7.svg";
export { ForwardRef as ReactComponent };